<ng-container *ngIf="canShowPdfExport">
  <div class="pdf-export">
    <span class="app-options-btn" id="DownloadLinks">
      Export results as:
      <a
        aria-label="clickable link PDF"
        tabindex="0"
        id="PDFLink"
        class="badge badge-pdf font-size-rem-point875 word-break-keep-all"
        (click)="onPdf()"
        (keypress)="onPDFKeyPress($event)"
        >PDF</a
      >&nbsp;
      <a
        aria-label="clickable link Excel"
        tabindex="0"
        id="ExcelLink"
        class="badge badge-xlxs font-size-rem-point875 word-break-keep-all"
        (click)="onExcel()"
        (keypress)="onExelKeyPress($event)"
        >XLSX</a
      >
    </span>
  </div>
</ng-container>
